//喜马拉雅横向滑动音频频道类
<template>
    <div class="view20Wrapper">
        <div class="tipsGlobalText" v-html="tips">
            {{tips}}
        </div>
        <CrossSlip>
            <BaseCard v-for="(item,ix) in list" :imgUrl="item.cover_url_small" :name="item.album_title" :hasNews="item.include_track_count" card-type="audio"  @on-click="()=>onAsk(item.id,item.cover_url_small,item.album_title,'喜马拉雅',item.include_track_count)" :key="`tips-quick-${ix}`"/>
        </CrossSlip>
    </div>
</template>


<script>
    import {mapActions} from 'vuex'
    import CrossSlip from '../Use/cross-slip-wrapper'
    import BaseCard from '../Use/base-card'
    export default {
        name: 'View21',
        components: {
            CrossSlip,BaseCard
        },
        props: {
            list: {
                type: Array,
                default: []
            },
            tips:{
                type: String,
                default: ''
            },
        },
        data () {
            return {

            }

        },
        mounted() {
            //给喜马拉雅回传数据 满足喜马拉雅上线要求
            let browse_records = []
            this.list.map((item)=>{browse_records.push({album_id: item.id, browsed_at: new Date().valueOf()})})
            this.asyncGetCallBack({payload: browse_records})
        },
        methods: {
            ...mapActions(["asyncGetCallBack"]),
            onAsk(id,cover,name,source,hasNews) {
                this.$emit("on-show",id, {id,cover,name,source,hasNews}, 10, 'white');
            }
        }
    }
</script>
<style lang="less" scoped>
    .view21Wrapper{

    }

</style>
